/**
 * Merge `R` into `T`, overriding any equal keys.
 */
export type MergeRight<T, R> = Omit<T, keyof R> & R;
